import { getRuntimeConfig } from "~/common/config/runtimeConfig";

const getHouseNumberOrStreetFirst = (): "houseNumber" | "street" =>
  getRuntimeConfig().houseNumberFirstInAddress ? "houseNumber" : "street";

export function createAddressLine1(houseNumber: string, street: string) {
  if (getHouseNumberOrStreetFirst() === "houseNumber") {
    return houseNumber + " " + street;
  } else {
    return street + " " + houseNumber;
  }
}

export function splitAddressLine1(line: string) {
  const parts = line.split(" ");

  const houseNumber = (getHouseNumberOrStreetFirst() === "houseNumber" ? parts.shift() : parts.pop()) ?? "";
  const street = parts.join(" ");

  return {
    street,
    houseNumber,
  };
}
